import {
  ZIP_CODE_MAP_ZOOM,
  STRUCTURE_MAP_ZOOM,
  ADDRESS_VERIFICATION_STRUCTURE_ZOOM,
} from './BingMap.constants';

export const MAP_VIEW_CONTEXT = {
  ORDER: 'order',
  ADDRESS_VERIFICATION: 'addressVerification',
};

export const getStructureMapZoom = (context = MAP_VIEW_CONTEXT.ORDER) => (
  context === MAP_VIEW_CONTEXT.ADDRESS_VERIFICATION
    ? ADDRESS_VERIFICATION_STRUCTURE_ZOOM
    : STRUCTURE_MAP_ZOOM
);

/** Zoom for the map after geocode; structure zoom once the user has placed the pin. */
export const getMapZoomForPoint = ({
  usedZipFallback,
  userMovedThePin,
  structureZoom = STRUCTURE_MAP_ZOOM,
  zipZoom = ZIP_CODE_MAP_ZOOM,
}) => (
  usedZipFallback && !userMovedThePin ? zipZoom : structureZoom
);

/** Identity of a geocode result — coords only, so address edits are not a new search. */
export const getGeocodeViewKey = ({ latitude, longitude }) => (
  `${latitude},${longitude}`
);

/**
 * Whether to apply center/zoom.
 * - First time points render (mount / remount): always center so pins are visible.
 * - Later updates: only on a new geocode before the user moves the pin.
 */
export const shouldApplyInitialMapView = ({
  hasInitializedView,
  userMovedThePin,
  geocodeViewKey,
  appliedGeocodeViewKey,
}) => {
  if (!hasInitializedView) return true;
  if (userMovedThePin) return false;
  return geocodeViewKey !== appliedGeocodeViewKey;
};
